/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_MatterportInputs */

const cs_projects_matterport = /** @type {(inputs: Projects_MatterportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matterport URL`)
};

const en_projects_matterport = /** @type {(inputs: Projects_MatterportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matterport URL`)
};

/**
* | output |
* | --- |
* | "Matterport URL" |
*
* @param {Projects_MatterportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_matterport = /** @type {((inputs?: Projects_MatterportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_MatterportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_matterport(inputs)
	return cs_projects_matterport(inputs)
});